(ns teamoesterreich.user-mode.news.news-list
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]))

(defn news-widget [uuid news]
  (let [open-news-fn (fn []
                       (swap! store/app-state assoc :selected-news uuid)
                       (a/set-page :news-detail))]
    [mui/grid
     {:item true
      :key  (str "news_" uuid)
      :lg   3
      :md   4
      :sm   6
      :xs   12
      }
     [mui/card
      {:style {:margin "20px" :height "450px" :overflow "hidden"}}
      [mui/card-action-area
       {:onClick open-news-fn}
       [mui/card-media
        {:component "img"
         :alt       (:title news)
         :image     (:header-image-uri news)
         :title     (:title news)
         :style     {:height "250" :backgroundColor "#e6e6e6"}
         }]
       [mui/card-header
        {:title                (r/as-element
                                 [:p (.toLocaleDateString (js/Date. (* 1000 (.-seconds ^js (:date news))))) [:br] (:title news)])
         :style                {:height "150px" :overflow-y "hidden"}
         :subtitle             (:content news)
         :actAsExpander        true
         :showExpandableButton true
         }
        ]
       ]
      [mui/card-actions
       [mui/button
        {:onClick open-news-fn}
        "Lesen"]
       [:span (when (not (:published news)) "[NICHT VERÖFFENTLICHT]  ")]]
      ]]
    ))


(defn get-it []
  (let [!publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)
        !news-list (r/cursor store/app-state [:news])
        news-list (reverse (sort-by (fn [[uuid n]] (.-seconds ^js (:date n))) @!news-list))]

    (log/out "news " news-list @!publisher @!publisher-mode)
    [:div
     [:h2 (txt/txt :core "Team News")]
     [mui/grid
      {:container  true
       :direction  "row"
       :justify    "center"
       :alignItems "stretch"
       :spacing    5
       :style      {}
       }
      (for [[uuid news] (if show-unpublished?
                          (filter (fn [[uuid news]] (and (:active news)
                                                         (< (* (.-seconds ^js (:date news)) 1000) (js/Date.now))
                                                         )) news-list)
                          (filter (fn [[uuid news]] (and (:active news)
                                                         (:published news)
                                                         (< (* (.-seconds ^js (:date news)) 1000) (js/Date.now))
                                                         )) news-list))]
        ^{:key (str "news-block-" uuid)} [news-widget uuid news])
      ]
     [mui/grid
      {:container false
       :xs        12

       }
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "space-between"
        :alignItems "flex-start"
        :spacing    1
        }
       [mui/grid
        {:container false
         :lg        8
         :xs        12
         :style     {:padding "15px"}
         }
        [mui/button
         {:variant "contained"
          :onClick #(a/set-page-back)
          }
         "Zurück"]]]]
     ]
    ))
